export const WORK_STATISTICS_DATE_RANGE_MAX_DAYS = 366

export const getWorkStatisticsDateRangeError = (startDate: Date, endDate: Date) => {
  if (endDate.getTime() < startDate.getTime()) {
    return 'End time cannot be earlier than start time.'
  }

  const startDay = Date.UTC(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  )
  const endDay = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())

  const millisecondsPerDay = 24 * 60 * 60 * 1000
  const differenceInDays = (endDay - startDay) / millisecondsPerDay

  if (differenceInDays > WORK_STATISTICS_DATE_RANGE_MAX_DAYS) {
    return 'Time range cannot exceed 1 year.'
  }

  return null
}
